// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"621b1182","144":"4b4634d4","488":"a3326d38","506":"0a0e67c2"}[chunkId] + ".chunk.js";
};